<template>
	<v-container>
		<v-row justify="center" align="center" :style="!isMobile && 'height: 100%'">
			<v-col cols="12" md="6">
				<v-card outlined :loading="fetchLoading" min-height="120">
					<v-card-text v-if="fetchLoading" class="caption">Cargando...</v-card-text>
					<template v-else>
						<template v-if="lodging && !confirmation">
							<v-card-text class="subtitle-1 text--secondary text-center">
								¿Quieres confirmar la actividad para el dia {{ lodging.start }}?
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="primary"
									@click="sendEmailToAdmin(true)"
									:disabled="disabled"
								>
									Confirmar
								</v-btn>
								<v-btn
									color="primary"
									@click="sendEmailToAdmin(false)"
									:disabled="disabled"
								>
									Reagendar
								</v-btn>
								<v-spacer></v-spacer>
							</v-card-actions>
						</template>
						<template v-if="confirmation">
							<v-card-text
								class="title green--text text-center"
								v-if="confirmationStatus === 1"
							>
								Actividad confirmada
							</v-card-text>
							<v-card-text
								class="title red--text text-center"
								v-else-if="confirmationStatus === 2"
							>
								Actividad rechazada
							</v-card-text>
						</template>
					</template>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapMutations } from 'vuex';
import { api as baseURL } from '@/config/index.js';
import evaluateErrorReturn from '@/utils/errors/evaluateErrorReturn';
export default {
	data() {
		return {
			guestPersonregister: false,
			fetchLoading: false,
			token: '',
			idPerson: '',
			idLodging: '',
			idNotification: '',
			person: null,
			lodging: null,
			disabled: false,
			confirmation: false,
			confirmationStatus: '0',
			place: '',
		};
	},
	created() {
		this.idLodging = this.$route.params.idLodging;
	},
	mounted() {
		this.initialFetch();
	},
	methods: {
		formatDate(date) {
			return moment(date).format('DD-MM-YYYY HH:mm');
		},
		async initialFetch() {
			try {
				this.fetchLoading = true;
				await this.getLodging();
			} catch (error) {
				this.snackbar({
					content: this.errorMessage(error),
					color: 'error',
				});
			} finally {
				this.fetchLoading = false;
			}
		},
		async getLodging() {
			const { data } = await axios.get(`${baseURL}/lodgings/no-auth/${this.idLodging}`, {});
			this.lodging = data.lodging;
			const notification = this.lodging.userNotifications?.find(
				notification => notification.type == 'client'
			);
			if (notification) {
				this.confirmation = true;
				this.confirmationStatus = notification.state;
			}
		},
		async sendEmailToAdmin(status) {
			try {
				this.fetchLoading = true;
				await axios(`${baseURL}/lodging/${this.idLodging}/client-confirmation`, {
					method: 'post',
					data: { status },
				});
				this.fetchLoading = false;
				this.confirmation = true;
				await this.getLodging();
			} catch (e) {
				this.snackbar({
					content: evaluateErrorReturn(this.errorMessage(e)),
					color: 'error',
				});
			}
		},
		disabledBtn() {
			this.disabled = !this.disabled;
		},
		errorMessage(e) {
			const status = e.response.status === 401;
			return status ? 'Ha expirado este enlace' : e;
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
			setPerson: 'Person/setPerson',
			setLodgingsOfPerson: 'Lodging/setLodgingsOfPerson',
		}),
	},
};
</script>
